import type {FunctionComponent} from 'react'
import type {DomainLogoProps} from '../../types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

const BestHouseholdPicksLogo: FunctionComponent<DomainLogoProps> = ({locale, ...attributes}) => {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-1 text-2xl font-semibold tablet:text-base">
      <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M27.815 22.035H9.18498C6.69498 22.035 5.19498 20.07 5.85498 17.67L9.15498 5.55C9.52998 4.155 11.045 3 12.485 3H24.515C25.955 3 27.47 4.155 27.845 5.55L31.145 17.67C31.805 20.07 30.305 22.035 27.815 22.035Z"
          fill="#222222"
        />
        <path
          d="M25.625 31.8749C25.625 32.4899 25.115 32.9999 24.5 32.9999H12.5C11.885 32.9999 11.375 32.4899 11.375 31.8749C11.375 31.2599 11.885 30.7499 12.5 30.7499H17.375V22.0349H19.625V30.7499H24.5C25.115 30.7499 25.625 31.2599 25.625 31.8749Z"
          fill="#222222"
        />
      </svg>
      <span>Best Household Picks</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}

export default BestHouseholdPicksLogo
